import { getCashDocumentsErrorCode, getCashDocumentsErrorMessage } from '../Utils/cashDocumentsErrorMapping';

const COMPANY_SCOPE_ERROR_MESSAGES: Record<string, string> = {
  CASH_DOCUMENT_COMPANY_REQUIRED:
    'Firma jest wymagana do wystawienia dokumentu kasowego. Wskaż firmę i spróbuj ponownie.',
  CASH_DOCUMENT_COMPANY_MISMATCH:
    'Wskazana firma nie zgadza się z kontekstem dokumentu kasowego. Sprawdź dane i spróbuj ponownie.',
  CASH_DOCUMENT_SOURCE_NOT_FOUND:
    'Nie znaleziono powiązanego dokumentu (faktura lub rezerwacja). Odśwież dane i spróbuj ponownie.',
};

export const getCashDocumentsCompanyScopeErrorMessage = (
  error: unknown,
  fallbackMessage: string
): string => {
  const errorCode = getCashDocumentsErrorCode(error);
  if (errorCode && COMPANY_SCOPE_ERROR_MESSAGES[errorCode]) {
    return COMPANY_SCOPE_ERROR_MESSAGES[errorCode];
  }
  return getCashDocumentsErrorMessage(error, fallbackMessage);
};
